"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _lodash = _interopRequireDefault(require("lodash"));

/**
 * TODO explain that you shouldn't store id, refresh, and access tokens together in cookies
 *
 *
 * for now only store refreshToken in cookies
 */
var CookieTokenStore = /*#__PURE__*/function () {
  /**
   *
   * @param { cookies } assume an instance of js-cookie
   */
  function CookieTokenStore(_ref) {
    var cookies = _ref.cookies,
        delegate = _ref.delegate,
        _ref$cookieOptions = _ref.cookieOptions,
        cookieOptions = _ref$cookieOptions === void 0 ? {
      refresh: {}
    } : _ref$cookieOptions;
    (0, _classCallCheck2["default"])(this, CookieTokenStore);
    this._cookieOptions = cookieOptions;
    this._delegate = delegate;
    this._cookies = cookies;
  }

  (0, _createClass2["default"])(CookieTokenStore, [{
    key: "updateTokens",
    value: function updateTokens(tokens) {
      var _this = this;

      var _cookieOptions = this._cookieOptions;

      _lodash["default"].each(tokens, function (token, name) {
        if (_cookieOptions[name]) {
          if (_lodash["default"].isNil(token)) {
            _this._cookies.remove(name);
          } else {
            _this[name] = token;
          }
        }
      });

      this._delegate.updateTokens(tokens);
    }
  }, {
    key: "clear",
    value: function clear() {
      this.updateTokens({
        id: null,
        refresh: null,
        access: null
      });
    }
  }, {
    key: "getToken",
    value: function getToken(name) {
      var _delegate = this._delegate,
          _cookieOptions = this._cookieOptions,
          _cookies = this._cookies;

      if (_cookieOptions[name]) {
        var value = _cookies.get(name);

        return _lodash["default"].isEmpty(value) ? null : value;
      } else {
        return _delegate[name];
      }
    }
  }, {
    key: "setCookie",
    value: function setCookie(name, value) {
      console.log('set cookie called');
      var _cookieOptions = this._cookieOptions,
          _cookies = this._cookies;

      if (!_cookieOptions[name]) {
        throw "not allowed to set ".concat(name, " token in cookie");
      }

      _cookies.set(name, value, _cookieOptions[name]);
    }
  }, {
    key: "access",
    get: function get() {
      return this.getToken('access');
    },
    set: function set(value) {
      this.setCookie('access', value);
    }
  }, {
    key: "id",
    get: function get() {
      return this.getToken('id');
    },
    set: function set(value) {
      this.setCookie('id', value);
    }
  }, {
    key: "refresh",
    get: function get() {
      return this.getToken('refresh');
    },
    set: function set(value) {
      this.setCookie('refresh', value);
    }
  }]);
  return CookieTokenStore;
}();

exports["default"] = CookieTokenStore;